<template>
    <div class="table-head">
        <div
            v-for="cell in tableHeadCells"
            :key="cell"
            class="cell"
            :class="getClassCell(cell)"
        >
            {{ cell }}
        </div>
    </div>
</template>

<script setup lang="ts">
const tableHeadCells = [
    'Shape',
    'Carat',
    'Colour',
    'Clarity',
    'Cut',
    'Polish',
    'Symmetry',
    'Price',
] as const

const getClassCell = (cell: (typeof tableHeadCells)[number]) =>
    cell.toLowerCase()
</script>

<style lang="scss" scoped>
.table-head {
    width: 100%;
    display: flex;
    height: 48px;
    align-items: center;
    border-bottom: 1px solid $grey-200;

    font-family: $effra-font-stack;
    font-size: 14px;
    font-weight: 400;
    line-height: 17.5px;
    letter-spacing: 0.05em;
    text-transform: uppercase;

    .cell {
        flex: 0 0 20%;
    }

    .cut,
    .polish,
    .symmetry {
        display: none;
    }

    @include min-width(768) {
        .cell {
            flex: 0 0 12%;
        }

        .cut,
        .polish,
        .symmetry {
            display: block;
            flex: 0 0 14%;
        }

        .price {
            flex: 0 0 10%;
        }
    }
}
</style>
